/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewPwAliases {
  BUTTON_NEW_PW = 'button-new-pw',
  BUTTON_OK = 'button-ok',
  FIELD_CONFIRM_PW = 'field-confirm-pw',
  FIELD_NEW_PW = 'field-new-pw',
  FORM_NEW_PW = 'form-new-pw',
  IMAGE_0 = 'image-0',
  IMAGE_NEW_PW = 'image-new-pw',
  INPUT_CONFIRM_PW = 'input-confirm-pw',
  INPUT_NEW_PW = 'input-new-pw',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_3 = 'layout-3',
  LAYOUT_NEW_PW = 'layout-new-pw',
  LOADER_0 = 'loader-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_HEADER = 'panel-header',
  PANEL_LOADER = 'panel-loader',
  PANEL_SCREEN = 'panel-screen',
  PANEL_SUCCESS = 'panel-success',
  PANEL_TITLE = 'panel-title',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_MESSAGE = 'text-message',
  TEXT_TITLE = 'text-title',
}
export { NewPwAliases };
